import { JSXElement, mergeProps } from 'solid-js';
import AgentPortalApiConnector from '~/api/AgentPortalApiConnector.tsx';
import AgentPortalAuthentication from '~/components/AppContainer/AgentPortalAuthentication.tsx';
import AgentPortalErrorBoundary from '~/components/ErrorBoundaries/AgentPortalErrorBoundary.tsx';

type AgentPortalContainerProps = {
  children: JSXElement;
};

export default function AgentPortalContainer(
  props: AgentPortalContainerProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <AgentPortalErrorBoundary>
      <AgentPortalApiConnector>
        <AgentPortalAuthentication>{merged.children}</AgentPortalAuthentication>
      </AgentPortalApiConnector>
    </AgentPortalErrorBoundary>
  );
}
